import {
  Heart,
  CalendarBlank,
  ArrowSquareRight,
  UsersThree,
  Church,
  HandHeart,
  Gift,
  Fingerprint
} from "@phosphor-icons/react";

const benefitsData = [
  {
    id: 1,
    icon: <Heart size={22} weight="fill" />,
    title: "Forming Leaders and Teams from the Laity",
    description:
      "We equip parishioners to become intentional disciples by guiding them toward a living relationship with Christ in the Eucharist. This is achieved through:",
    list: [
      "Education & Formation: Seminars, study guides, and educational materials that deepen understanding of the Real Presence.",
      "Worship & Adoration: Encouraging regular participation in Mass and Adoration to strengthen Eucharistic devotion.",
      "Personal Prayer & Reflection: Nurturing personal spirituality centered on the Eucharist.",
      "Community & Fellowship: Small groups and parish gatherings for shared prayer, discussion, and mutual support.",
      "Living the Eucharist Daily: Encouraging parishioners to embody the love of Christ through service, charity, and witness."
    ]
  },
  {
    id: 2,
    icon: <CalendarBlank size={22} weight="fill" />,
    title: "Events by Design",
    description:
      "These events are not just informative — they're formative. They cultivate a space where hearts are opened, doubts are addressed, and lives are changed.",
    list: [
      "Planned with Purpose - We use the Liturgical Calendar as a framework to schedule events that align with the rhythms of the Church year. From Advent to Ordinary Time, each gathering is designed to deepen Eucharistic understanding through the lens of the season.",
      "Building Authentic Community - Each event includes a shared meal, short video presentations, and table discussions that invite parishioners to reflect, connect, and grow together in faith. These gatherings foster true communion — with Christ and with one another.",
      "Creating a Eucharistic Atmosphere - We help parishes set the tone with thoughtful table settings, with intentional hospitality. The goal is to create a comfortable and welcoming environment where dialogue about the Eucharist and our faith can flourish."
    ]
  },
  {
    id: 3,
    icon: <ArrowSquareRight size={22} weight="fill" />,
    title: "Transforming Parish Life",
    description: "Beyond Baptism revitalizes parish culture through:",
    list: [
      "Renewed Spiritual Vitality: A deeper focus on the Eucharist transforms participation in the sacraments and parish events.",
      "Stronger Community Bonds: Eucharist-centered groups and events promote unity, friendship, and belonging.",
      "Increased Engagement: As faith deepens, so does participation—in liturgy, ministries, and outreach.",
      "Ongoing Discipleship: Ongoing spiritual formation prepares parishioners to be lifelong disciples and evangelizers.",
      "Mission-Driven Outreach: Empowered by the Eucharist, parishioners become missionary disciples both inside and beyond parish walls."
    ]
  },
  {
    id: 4,
    icon: <UsersThree size={22} weight="fill" />,
    title: "Building a Eucharistic Community",
    description:
      "Beyond Baptism integrates Eucharistic spirituality into every dimension of parish life:",
    list: [
      "Liturgical Integration: The Eucharist becomes the source and summit of all parish activity.",
      "Encounters with Christ: Through Mass and Adoration, parishioners experience the living presence of Jesus.",
      "Education & Formation: Formation on the Eucharist enables deeper, more meaningful worship.",
      "Community Building: Eucharistic worship unites the parish around a common identity in Christ."
    ]
  },
  {
    id: 5,
    icon: <Church size={22} weight="fill" />,
    title: "Adoration Inspires Vocation",
    description:
      "There is a strong connection between Eucharistic Adoration and the flourishing of vocations:",
    list: [
      "Personal Encounter with Christ: In the stillness of Adoration, individuals hear God's call more clearly.",
      "Discernment through Prayer: Adoration creates the silence and space needed for vocational clarity.",
      "A Culture of Prayer: Communities grounded in Adoration witness a rise in vocations, guided by a shared spiritual depth.",
      "Living Eucharistic Spirituality: This atmosphere inspires individuals to serve the Church in radical, joyful ways."
    ]
  },
  {
    id: 6,
    icon: <Gift size={22} weight="fill" />,
    title: "Cost-Free—By Design",
    description:
      "We believe every parish should have access to quality formation—regardless of financial status. That’s why Beyond Baptism is offered at no cost. \n\nParishes may incur minor local expenses (e.g., food for gatherings, printing materials, or a small training fee, usually under $300), but the core program is fully funded by our team and supporters. \n\nWe welcome donations and partnerships to help sustain this mission and expand to more parishes in need.",
    list: []
  },
  {
    id: 7,
    icon: <HandHeart size={22} weight="fill" />,
    title: "Helping Overwhelmed Pastors",
    description:
      "We recognize the heavy demands on today’s clergy. Beyond Baptism is designed to:",
    list: [
      "Empower Laity: By equipping lay leaders, we ease the burden on pastors.",
      "Provide Ready-to-Use Resources: We offer everything needed to launch and sustain ministry efforts",
      "Foster Parish-Wide Collaboration: Our model strengthens cohesion across ministries.",
      "Offer Spiritual Support: We provide encouragement not just to parishioners—but to pastors too."
    ]
  },
  {
    id: 8,
    icon: <Fingerprint size={22} weight="fill" />,
    title: "Why Beyond Baptism Stands Apart",
    description: "We go beyond frameworks and checklists. Here’s how we’re different:",
    list: [
      "Active Lay Involvement: We don’t just encourage volunteerism—we recruit, train, and support lay leaders.",
      "Pastor-Friendly: Our programs operate with minimal involvement from the pastor, freeing clergy to focus on sacramental and pastoral priorities.",
      "Leadership Development: We build in succession planning, ensuring long-term stability and growth.",
      "Ongoing Spiritual Formation: Our work begins where Baptism ends—continuing the journey of discipleship.",
      "Eucharistic Focus: Every aspect of our ministry is rooted in the transforming power of the Real Presence.",
      "Holistic Discipleship: We help parishioners grow in prayer, formation, community life, and service.",
      "Community-Oriented: Our emphasis on fellowship strengthens parish identity and shared mission."
    ]
  }
];

export default benefitsData;
